export default __webpack_public_path__ + "static/pop-9ec897f1b3cf2d005db304fc00053fa7.mp3";